import SEO from '../components/SEO';

const ShippingPage = () => {
  return (
    <>
      <SEO
        title="Service Fulfillment Policy"
        description="Learn how AdOnRoads fulfills billboard advertising services."
      />

      <div className="pt-24 pb-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-secondary mb-6">Service Fulfillment Policy</h1>
          <p className="text-gray-600 mb-8">Effective Date: January 1, 2025</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">1. Nature of Service</h2>
              <p className="text-gray-700">
                AdOnRoads provides a digital marketplace for billboard advertising services. Unlike traditional e-commerce platforms, we do not ship physical products. Instead, we facilitate:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-4">
                <li>Digital booking and coordination of billboard advertising campaigns</li>
                <li>Connection between advertisers and verified billboard owners</li>
                <li>Campaign management and tracking tools</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">2. Service Delivery Process</h2>
              <p className="text-gray-700 mb-4">
                Once you book a billboard through AdOnRoads, the service fulfillment process works as follows:
              </p>
              <ol className="list-decimal pl-6 space-y-2 text-gray-700">
                <li><strong>Booking Confirmation:</strong> You receive instant confirmation of your booking via email and dashboard</li>
                <li><strong>Partner Assignment:</strong> Your campaign is assigned to the verified local billboard partner</li>
                <li><strong>Material Submission:</strong> You submit your campaign materials through the platform</li>
                <li><strong>Installation:</strong> The billboard partner installs your advertisement at the scheduled start date</li>
                <li><strong>Campaign Monitoring:</strong> Track your active campaign through your dashboard</li>
                <li><strong>Completion:</strong> Campaign concludes on the scheduled end date</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">3. Timeline and Responsibilities</h2>
              <p className="text-gray-700 mb-4">
                <strong>Service Timeline:</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Campaign installation typically occurs on or before the scheduled start date</li>
                <li>Actual installation timeline depends on campaign start date and billboard partner confirmation</li>
                <li>Minimum 3 business days' notice required for campaign material changes</li>
              </ul>
              <p className="text-gray-700 mt-4 mb-4">
                <strong>Your Responsibilities:</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Provide campaign materials in the correct format and size</li>
                <li>Submit materials at least 3 days before campaign start date</li>
                <li>Ensure content complies with local advertising regulations</li>
                <li>Respond promptly to any partner requests for clarification</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">4. Billboard Partner Network</h2>
              <p className="text-gray-700">
                Billboard execution is handled by our verified local partner network. All partners are:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-4">
                <li>Verified for quality and reliability</li>
                <li>Licensed and permitted for billboard operations</li>
                <li>Experienced in outdoor advertising execution</li>
                <li>Subject to regular performance reviews</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">5. Quality Assurance</h2>
              <p className="text-gray-700">
                We ensure quality service delivery through:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-4">
                <li>Installation confirmation photos provided to clients</li>
                <li>Regular monitoring of campaign status</li>
                <li>Partner performance tracking and ratings</li>
                <li>Dedicated support for any installation issues</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">6. Service Issues and Support</h2>
              <p className="text-gray-700">
                If you experience any issues with service fulfillment:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-4">
                <li>Contact our support team immediately at <a href="mailto:support@adonroads.com" className="text-accent hover:underline">support@adonroads.com</a></li>
                <li>Provide your booking ID and description of the issue</li>
                <li>We'll work with our partner network to resolve issues promptly</li>
                <li>Compensation may be provided for verified service failures</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">7. Force Majeure</h2>
              <p className="text-gray-700">
                Service delivery may be affected by circumstances beyond our control, including natural disasters, government restrictions, or infrastructure damage. In such cases, we will work with you to reschedule or provide appropriate alternatives.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">8. Questions?</h2>
              <p className="text-gray-700">
                For questions about service fulfillment, please contact <a href="mailto:support@adonroads.com" className="text-accent hover:underline">support@adonroads.com</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShippingPage;